import { render, staticRenderFns } from "./BusinessNameDetailsMessages.vue?vue&type=template&id=010e1cd5&scoped=true&"
import script from "./BusinessNameDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e1cd5",
  null
  
)

export default component.exports